import { FileText, AlertTriangle, Clock, CreditCard, Mail, Ticket, RefreshCw, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Terms = () => {
  return (
    <div className="min-h-screen pt-24" data-testid="terms-page">
      {/* Hero */}
      <section className="relative py-16 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-[var(--secondary)]/10 to-transparent" />
        <div className="section-container relative z-10">
          <span className="text-[var(--primary)] text-xs uppercase tracking-[0.3em] block mb-4">
            Legal
          </span>
          <h1 className="font-['Playfair_Display'] text-5xl md:text-6xl text-white mb-6">
            Condiciones de Compra
          </h1>
          <p className="text-white/70 max-w-3xl">
            Bienvenido a EventCinema.es, una plataforma gestionada por Versión Digital (en adelante, "la Empresa"). La adquisición de entradas a través de este portal implica la aceptación plena y sin reservas de las siguientes condiciones de compra.
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="section-container py-12">
        <div className="max-w-4xl mx-auto space-y-12">
          
          {/* Section 1 */}
          <div className="p-6 bg-[var(--surface)] border border-white/5">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-10 h-10 bg-[var(--primary)]/20 flex items-center justify-center flex-shrink-0">
                <FileText size={20} className="text-[var(--primary)]" />
              </div>
              <div>
                <h2 className="font-['Playfair_Display'] text-2xl text-white">1. DESCRIPCIÓN DEL SERVICIO</h2>
              </div>
            </div>
            <div className="text-white/70 space-y-4 pl-14">
              <p>EventCinema.es es un marketplace de venta anticipada de entradas para contenidos culturales (ópera, ballet, arte, conciertos) en cines seleccionados.</p>
              <p>Nuestro modelo se basa en la gestión de aforo (yield management), ofreciendo precios reducidos a cambio de condiciones de venta específicas (venta anticipada y asignación automática de localidad).</p>
            </div>
          </div>

          {/* Section 2 - SMART */}
          <div className="p-6 bg-[var(--surface)] border border-[var(--primary)]/30">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-10 h-10 bg-[var(--primary)]/20 flex items-center justify-center flex-shrink-0">
                <Ticket size={20} className="text-[var(--primary)]" />
              </div>
              <div>
                <h2 className="font-['Playfair_Display'] text-2xl text-white">2. SISTEMA "SMART": ASIGNACIÓN DE BUTACAS</h2>
              </div>
            </div>
            <div className="text-white/70 space-y-4 pl-14">
              <p>Al comprar en EventCinema.es, el Usuario acepta y comprende la naturaleza del servicio:</p>
              <ul className="space-y-3">
                <li className="flex gap-2">
                  <span className="text-[var(--primary)] font-bold">•</span>
                  <span><strong className="text-white">Asignación Automática:</strong> La asignación de la localidad será realizada automáticamente por el sistema o la sala de cine en función de la disponibilidad del cupo promocional.</span>
                </li>
                <li className="flex gap-2">
                  <span className="text-[var(--primary)] font-bold">•</span>
                  <span><strong className="text-white">Ubicación:</strong> Las entradas suelen corresponder a zonas de aforo de baja ocupación designadas por el Exhibidor (habitualmente filas delanteras o zonas laterales), aunque garantizan siempre la visibilidad completa del espectáculo.</span>
                </li>
                <li className="flex gap-2">
                  <span className="text-[var(--primary)] font-bold">•</span>
                  <span><strong className="text-white">Imposibilidad de Reclamación:</strong> No se admitirán reclamaciones ni solicitudes de cambio basadas en la ubicación de la butaca asignada una vez finalizada la compra.</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Section 3 */}
          <div className="p-6 bg-[var(--surface)] border border-white/5">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-10 h-10 bg-[var(--primary)]/20 flex items-center justify-center flex-shrink-0">
                <Clock size={20} className="text-[var(--primary)]" />
              </div>
              <div>
                <h2 className="font-['Playfair_Display'] text-2xl text-white">3. PLAZOS DE VENTA Y CIERRE</h2>
              </div>
            </div>
            <div className="text-white/70 space-y-4 pl-14">
              <p>La venta en este portal es exclusivamente anticipada.</p>
              <p className="text-[var(--primary)] font-medium">El canal de venta para cada evento se cerrará definitivamente 48 horas antes del inicio de la sesión (según lo indicado en la ficha de cada evento).</p>
              <p>Una vez cerrado el plazo, no será posible adquirir entradas a precio promocional, debiendo el Usuario acudir a los canales oficiales del cine a precio estándar si desea asistir.</p>
            </div>
          </div>

          {/* Section 4 */}
          <div className="p-6 bg-[var(--surface)] border border-white/5">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-10 h-10 bg-[var(--primary)]/20 flex items-center justify-center flex-shrink-0">
                <CreditCard size={20} className="text-[var(--primary)]" />
              </div>
              <div>
                <h2 className="font-['Playfair_Display'] text-2xl text-white">4. PRECIOS Y FORMAS DE PAGO</h2>
              </div>
            </div>
            <div className="text-white/70 space-y-4 pl-14">
              <p>Los precios indicados incluyen el IVA y cualquier otro impuesto aplicable vigente en el momento de la compra.</p>
              <p>El descuento aplicado (hasta un 25%) se calcula sobre el precio oficial de taquilla proporcionado por el Exhibidor.</p>
              <p>El pago se realizará mediante pasarela de pago segura (Tarjeta de crédito/débito, Bizum, etc.). La entrada no se considerará confirmada hasta que el pago haya sido validado por la entidad bancaria.</p>
            </div>
          </div>

          {/* Section 5 */}
          <div className="p-6 bg-[var(--surface)] border border-white/5">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-10 h-10 bg-[var(--primary)]/20 flex items-center justify-center flex-shrink-0">
                <CheckCircle size={20} className="text-[var(--primary)]" />
              </div>
              <div>
                <h2 className="font-['Playfair_Display'] text-2xl text-white">5. ENTREGA DE ENTRADAS Y ACCESO AL CINE</h2>
              </div>
            </div>
            <div className="text-white/70 space-y-4 pl-14">
              <p>Tras la compra, el Usuario recibirá un correo electrónico con el Comprobante de Reserva.</p>
              <p><strong className="text-white">Importante:</strong> Dependiendo de la operativa del cine seleccionado, el Usuario deberá:</p>
              <ul className="space-y-2 ml-4">
                <li><strong className="text-[var(--primary)]">Opción A (Canje):</strong> Presentar el comprobante en la taquilla del cine (impreso o en el móvil) para recibir su entrada física numerada.</li>
                <li><strong className="text-[var(--primary)]">Opción B (Acceso Directo):</strong> Acceder directamente al punto de control de entradas con el código QR facilitado.</li>
              </ul>
              <p>Es responsabilidad del Usuario comprobar en su email las instrucciones específicas para su cine.</p>
            </div>
          </div>

          {/* Section 6 - Warning */}
          <div className="p-6 bg-red-950/30 border border-red-500/30">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-10 h-10 bg-red-500/20 flex items-center justify-center flex-shrink-0">
                <AlertTriangle size={20} className="text-red-400" />
              </div>
              <div>
                <h2 className="font-['Playfair_Display'] text-2xl text-white">6. POLÍTICA DE CAMBIOS, DEVOLUCIONES Y DESISTIMIENTO</h2>
              </div>
            </div>
            <div className="text-white/70 space-y-4 pl-14">
              <p><strong className="text-red-400">Excepción al Derecho de Desistimiento:</strong> De conformidad con la normativa vigente en materia de consumidores y usuarios (Ley General para la Defensa de los Consumidores y Usuarios), el derecho de desistimiento no es aplicable a los contratos de servicios de esparcimiento si los mismos prevén una fecha o un periodo de ejecución específicos.</p>
              <p><strong className="text-red-400">Política Estricta:</strong> Por tanto, NO SE ADMITEN CAMBIOS NI DEVOLUCIONES una vez confirmada la compra, salvo en los casos de cancelación o modificación sustancial del evento por parte del organizador.</p>
              <p><strong className="text-white">Errores en la compra:</strong> No se procederá a la devolución por errores en la selección de fecha, ciudad o cine por parte del Usuario.</p>
            </div>
          </div>

          {/* Section 7 */}
          <div className="p-6 bg-[var(--surface)] border border-white/5">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-10 h-10 bg-[var(--primary)]/20 flex items-center justify-center flex-shrink-0">
                <RefreshCw size={20} className="text-[var(--primary)]" />
              </div>
              <div>
                <h2 className="font-['Playfair_Display'] text-2xl text-white">7. CANCELACIÓN O MODIFICACIÓN DEL EVENTO</h2>
              </div>
            </div>
            <div className="text-white/70 space-y-4 pl-14">
              <p>En caso de cancelación del evento por causas imputables a la Distribuidora o al Cine, se procederá a la devolución íntegra del importe abonado por el mismo medio de pago utilizado.</p>
              <p>Si el evento se suspende una vez comenzado por causas de fuerza mayor, no habrá lugar a devolución, siguiendo la política general del cine organizador.</p>
            </div>
          </div>

          {/* Section 8 */}
          <div className="p-6 bg-[var(--surface)] border border-white/5">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-10 h-10 bg-[var(--primary)]/20 flex items-center justify-center flex-shrink-0">
                <Mail size={20} className="text-[var(--primary)]" />
              </div>
              <div>
                <h2 className="font-['Playfair_Display'] text-2xl text-white">8. ATENCIÓN AL CLIENTE</h2>
              </div>
            </div>
            <div className="text-white/70 space-y-4 pl-14">
              <p>Para cualquier duda o incidencia relacionada con su compra, puede contactar con nosotros a través de:</p>
              <p><strong className="text-white">Email:</strong> <a href="mailto:entradas@eventcinema.es" className="text-[var(--primary)] hover:underline">entradas@eventcinema.es</a></p>
              <p><strong className="text-white">Horario:</strong> Lunes a Jueves de 9:00 a 18:00. Viernes de 9:00 a 14:00.</p>
            </div>
          </div>

          {/* Section 9 */}
          <div className="p-6 bg-[var(--primary)]/10 border border-[var(--primary)]/30">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-10 h-10 bg-[var(--primary)]/20 flex items-center justify-center flex-shrink-0">
                <CheckCircle size={20} className="text-[var(--primary)]" />
              </div>
              <div>
                <h2 className="font-['Playfair_Display'] text-2xl text-white">9. ACEPTACIÓN</h2>
              </div>
            </div>
            <div className="text-white/70 pl-14">
              <p>La confirmación de la compra implica la aceptación expresa de estas condiciones, así como de las normas de acceso y comportamiento propias de la sala de cine donde se celebre el evento.</p>
            </div>
          </div>

          {/* Back link */}
          <div className="text-center pt-8">
            <Link to="/sobre-nosotros" className="btn-outline inline-flex items-center gap-2">
              Sobre Nosotros
            </Link>
            <Link to="/catalogo" className="btn-primary inline-flex items-center gap-2 ml-4">
              Ver Eventos
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
